import { LaunchSources, RoomTypes } from '~analytics/types';

import { sendLaunchMultipleChoiceEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class LaunchMultipleChoiceEventAdapter extends EventAdapter {
  protected intercomEventKey = 'launch-multiple-choice';
  protected amplitudeEventFunction = sendLaunchMultipleChoiceEvent;

  constructor(
    isRosteredRoom: boolean,
    launchSource: LaunchSources = LaunchSources.LaunchScreen
  ) {
    super();

    try {
      const roomType = isRosteredRoom
        ? RoomTypes.RosteredRoom
        : RoomTypes.OpenRoom;
      this.eventData = {
        room_type: roomType,
        launch_source: launchSource,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
